import React, { PureComponent, createContext } from 'react';
import _blacklist from '../blacklist';
import _constants from '../constants';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _blacklist2 = _interopRequireDefault(_blacklist);
var _constants2 = _interopRequireDefault(_constants);

const { Provider, Consumer } = createContext({ width: 0, height: 0 });
class Col extends PureComponent {
  state = this.getDimensions();

  componentDidMount() {
    if (typeof window !== 'undefined') window.addEventListener('resize', this.updateDimensions);
  }
  componentWillUnmount() {
    if (typeof window !== 'undefined') window.removeEventListener('resize', this.updateDimensions);
  }
  updateDimensions = () => {
    this.setState(this.getDimensions());
  };

  getDimensions() {
    const w = window;
    const d = document;
    const documentElement = d.documentElement;
    const body = d.getElementsByTagName('body')[0];
    const windowWidth = w.innerWidth || documentElement.clientWidth || body.clientWidth;

    return { windowWidth };
  }

  render() {
    var _props = this.props;
    var basis = _props.basis;
    var gutter = _props.gutter || _constants2['default'].width.gutter;
    var xs = _props.xs;
    var sm = _props.sm;
    var md = _props.md;
    var lg = _props.lg;
    var windowWidth = this.state.windowWidth;

    var columnStyle = {
      minHeight: 1,
      paddingLeft: gutter / 2,
      paddingRight: gutter / 2
    };

    // if no width control is provided fill available space
    if (!basis && !xs && !sm && !md && !lg) {
      columnStyle.flex = '1 1 auto';
      columnStyle.msFlex = '1 1 auto';
      columnStyle.WebkitFlex = '1 1 auto';
    }

    // set widths / flex-basis
    if (basis) {
      columnStyle.flex = '1 0 ' + basis;
      columnStyle.msFlex = '1 0 ' + basis;
      columnStyle.WebkitFlex = '1 0 ' + basis;
    } else if (windowWidth < _constants2['default'].breakpoint.xs) {
      columnStyle.width = xs;
    } else if (windowWidth < _constants2['default'].breakpoint.sm) {
      columnStyle.width = sm || xs;
    } else if (windowWidth < _constants2['default'].breakpoint.md) {
      columnStyle.width = md || sm || xs;
    } else {
      columnStyle.width = lg || md || sm || xs;
    }

    if (!columnStyle.width) {
      columnStyle.width = '100%';
    }

    if (columnStyle.width in _constants2['default'].fractions) {
      columnStyle.width = _constants2['default'].fractions[columnStyle.width];
    }

    var props = (0, _blacklist2['default'])(this.props, 'basis', 'gutter', 'style', 'xs', 'sm', 'md', 'lg');

    return React.createElement('div', _extends({ style: _extends(columnStyle, this.props.style), className: "Col" }, props));
  }
};

export default Col;